//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React from 'react';
import { commonStyles } from '../../styles/commonStyles';
import Solutions from './solutions';
import CuratedData from './curatedata';
import Resources from './resources';
import NavButtons from './NavButtons';
import Footer from './Footer';

function Home() {
  return (
    <div
      data-testid={'home-container'}
      id="home-container"
      style={{
        ...commonStyles.container,
        flexDirection: 'column',
      }}
    >
      <div>
        <NavButtons />

        <Solutions />

        <div id="main-content" data-testid="home-main-content">
          {/* <CuratedData /> */}
          <Resources />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
